import http from './config'

export default {
  lista: () => {
    return http.get('/api/v1/beneficiario')
  },
  dadosConfirmar: (dadosConfirmar) => {
    return http.post('/api/v1/beneficiario/dados-confirmacao', dadosConfirmar)
  }
}
